import styled from 'styled-components';

export const StyledIcon = styled.i`
    font-family: 'Ratiodata Icons';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    font-weight: normal;
    line-height: 1;
`;

export const Expand = styled(StyledIcon)`
    &:before {
        content:'\\e301';
    }
`;

export const CameraButton = styled(StyledIcon)`
    &:before {
        content:'\\e302';
    }
`;

export const Play = styled(StyledIcon)`
    &:before {
        content:'\\e305';
    }
`;

export const Pause = styled(StyledIcon)`
    &:before {
        content:'\\e306';
    }
`;

export const Stop = styled(StyledIcon)`
    &:before {
        content:'\\e307';
    }
`;

export const Microphone = styled(StyledIcon)`
    &:before {
        content:'\\e308';
    }
`;

export const Collapse = styled(StyledIcon)`
    &:before {
        content:'\\e309';
    }
`;

export const Check = styled(StyledIcon)`
    &:before {
        content:'\\e323';
    }
`;

export const CollapseAlt = styled(StyledIcon)`
    &:before {
        content:'\\e354';
    }
`;

export const ExpandAlt = styled(StyledIcon)`
    &:before {
        content:'\\e355';
    }
`;

export const HistoryClock = styled(StyledIcon)`
    &:before {
        content:'\\e356';
    }
`;

export const ArrowDown = styled(StyledIcon)`
    &:before {
        content:'\\e900';
    }
`;

export const ArrowLeft = styled(StyledIcon)`
    &:before {
        content:'\\e901';
    }
`;

export const ArrowRight = styled(StyledIcon)`
    &:before {
        content:'\\e902';
    }
`;

export const ArrowTop = styled(StyledIcon)`
    &:before {
        content:'\\e903';
    }
`;

export const Calendar = styled(StyledIcon)`
    &:before {
        content:'\\e904';
    }
`;

export const Call = styled(StyledIcon)`
    &:before {
        content:'\\e905';
    }
`;

export const CheckmarkRadio = styled(StyledIcon)`
    &:before {
        content:'\\e906';
    }
`;

export const CheckmarkSimple = styled(StyledIcon)`
    &:before {
        content:'\\e907';
    }
`;

export const Clock = styled(StyledIcon)`
    &:before {
        content:'\\e908';
    }
`;

export const Comment = styled(StyledIcon)`
    &:before {
        content:'\\e909';
    }
`;

export const Filter = styled(StyledIcon)`
    &:before {
        content:'\\e90b';
    }
`;

export const Add = styled(StyledIcon)`
    &:before {
        content:'\\e90b';
    }
`;

export const Info = styled(StyledIcon)`
    &:before {
        content:'\\e90c';
    }
`;

export const Location = styled(StyledIcon)`
    &:before {
        content:'\\e90d';
    }
`;

export const Lock = styled(StyledIcon)`
    &:before {
        content:'\\e90e';
    }
`;

export const SmallArrowDown = styled(StyledIcon)`
    &:before {
        content:'\\e90f';
    }
`;

export const SmallArrowLeft = styled(StyledIcon)`
    &:before {
        content:'\\e910';
    }
`;

export const SmallArrowRight = styled(StyledIcon)`
    &:before {
        content:'\\e911';
    }
`;

export const SmallArrowUp = styled(StyledIcon)`
    &:before {
        content:'\\e912';
    }
`;

export const Trash = styled(StyledIcon)`
    &:before {
        content:'\\e913';
    }
`;

export const Warning = styled(StyledIcon)`
    &:before {
        content:'\\e914';
    }
`;

export const CameraGridBottomLeft = styled(StyledIcon)`
    &:before {
        content:'\\e915';
    }
`;

export const CameraGridBottomRight = styled(StyledIcon)`
    &:before {
        content:'\\e916';
    }
`;

export const CameraGridTopLeft = styled(StyledIcon)`
    &:before {
        content:'\\e917';
    }
`;

export const CameraGridTopRight = styled(StyledIcon)`
    &:before {
        content:'\\e918';
    }
`;

export const Flash = styled(StyledIcon)`
    &:before {
        content:'\\e919';
    }
`;

export const FlashDisabled = styled(StyledIcon)`
    &:before {
        content:'\\e91a';
    }
`;

export const Invalid = styled(StyledIcon)`
    &:before {
        content:'\\e91b';
    }
`;

export const Close = styled(StyledIcon)`
    &:before {
        content:'\\e91c';
    }
`;

export const BarCode = styled(StyledIcon)`
    &:before {
        content:'\\e91d';
    }
`;

export const MoreOptions = styled(StyledIcon)`
    &:before {
        content:'\\e91e';
    }
`;

export const Substract = styled(StyledIcon)`
    &:before {
        content:'\\e91f';
    }
`;

export const CheckmarkSquare = styled(StyledIcon)`
    &:before {
        content:'\\e920';
    }
`;

export const Company = styled(StyledIcon)`
    &:before {
        content:'\\e921';
    }
`;

export const InstanceNumber = styled(StyledIcon)`
    &:before {
        content:'\\e922';
    }
`;

export const NotificationBubble = styled(StyledIcon)`
    &:before {
        content:'\\e923';
    }
`;

export const EyeDisabled = styled(StyledIcon)`
    &:before {
        content:'\\e924';
    }
`;

export const FlashAuto = styled(StyledIcon)`
    &:before {
        content:'\\e925';
    }
`;

export const Camera = styled(StyledIcon)`
    &:before {
        content:'\\e926';
    }
`;

export const NotificationTriangle = styled(StyledIcon)`
    &:before {
        content:'\\e927';
    }
`;

export const EyeEnabled = styled(StyledIcon)`
    &:before {
        content:'\\e928';
    }
`;

export const NotificationBell = styled(StyledIcon)`
    &:before {
        content:'\\e929';
    }
`;

export const CloseFill = styled(StyledIcon)`
    &:before {
        content:'\\e92a';
    }
`;

export const ColorOff = styled(StyledIcon)`
    &:before {
        content:'\\e92b';
    }
`;

export const ColorOn = styled(StyledIcon)`
    &:before {
        content:'\\e92c';
    }
`;

export const Download = styled(StyledIcon)`
    &:before {
        content:'\\e92d';
    }
`;

export const FilterExpand = styled(StyledIcon)`
    &:before {
        content:'\\e92e';
    }
`;

export const FilterNormal = styled(StyledIcon)`
    &:before {
        content:'\\e92f';
    }
`;

export const FilterTable = styled(StyledIcon)`
    &:before {
        content:'\\e930';
    }
`;

export const Locked = styled(StyledIcon)`
    &:before {
        content:'\\e931';
    }
`;

export const PartialmarkSquare = styled(StyledIcon)`
    &:before {
        content:'\\e932';
    }
`;

export const RotateLeft = styled(StyledIcon)`
    &:before {
        content:'\\e933';
    }
`;

export const RotateRight = styled(StyledIcon)`
    &:before {
        content:'\\e934';
    }
`;

export const Search = styled(StyledIcon)`
    &:before {
        content:'\\e935';
    }
`;

export const SelectorsRadioActive = styled(StyledIcon)`
    &:before {
        content:'\\e936';
    }
`;

export const SelectorsRadioNormal = styled(StyledIcon)`
    &:before {
        content:'\\e937';
    }
`;

export const SwapPages = styled(StyledIcon)`
    &:before {
        content:'\\e938';
    }
`;

export const UncheckedmarkSquare = styled(StyledIcon)`
    &:before {
        content:'\\e939';
    }
`;

export const Unlocked = styled(StyledIcon)`
    &:before {
        content:'\\e93a';
    }
`;

export const Upload = styled(StyledIcon)`
    &:before {
        content:'\\e93b';
    }
`;

export const ZoomIn = styled(StyledIcon)`
    &:before {
        content:'\\e93c';
    }
`;

export const Duplicate = styled(StyledIcon)`
    &:before {
        content:'\\e93d';
    }
`;

export const ZoomOut = styled(StyledIcon)`
    &:before {
        content:'\\e93e';
    }
`;

export const Tooltip = styled(StyledIcon)`
    &:before {
        content:'\\e93f';
    }
`;

export const Calendar2 = styled(StyledIcon)`
    &:before {
        content:'\\e940';
    }
`;

export const Calendar3 = styled(StyledIcon)`
    &:before {
        content:'\\e941';
    }
`;

export const Cutfile = styled(StyledIcon)`
    &:before {
        content:'\\e942';
    }
`;

export const CutfilePart = styled(StyledIcon)`
    &:after {
        content:'\\e943';
    }
`;

export const ArrowLeftEnd = styled(StyledIcon)`
    &:before {
        content:'\\e944';
    }
`;

export const ArrowRightEnd = styled(StyledIcon)`
    &:before {
        content:'\\e945';
    }
`;

export const Lock2 = styled(StyledIcon)`
    &:before {
        content:'\\e947';
    }
`;

export const Private = styled(StyledIcon)`
    &:before {
        content:'\\e949';
    }
`;

export const Repeating = styled(StyledIcon)`
    &:before {
        content:'\\e94a';
    }
`;

export const Send2 = styled(StyledIcon)`
    &:before {
        content:'\\e94b';
    }
`;

export const StarEmpty = styled(StyledIcon)`
    &:before {
        content:'\\e94c';
    }
`;

export const StarFilled = styled(StyledIcon)`
    &:before {
        content:'\\e94d';
    }
`;

export const TouchID = styled(StyledIcon)`
    &:before {
        content:'\\e94f';
    }
`;

export const NounSee = styled(StyledIcon)`
    &:before {
        content:'\\e950';
    }
`;

export const Edit = styled(StyledIcon)`
    &:before {
        content:'\\e951';
    }
`;

export const SmallArrowDown2 = styled(StyledIcon)`
    &:before {
        content:'\\e952';
    }
`;

export const Workspace = styled(StyledIcon)`
    &:before {
        content:'\\e953';
    }
`;

export const SmallArrowUp2 = styled(StyledIcon)`
    &:before {
        content:'\\e954';
    }
`;

export const SendCancel = styled(StyledIcon)`
    &:before {
        content:'\\e955';
    }
`;

export const IconBank = styled(StyledIcon)`
    &:before {
        content:'\\e956';
    }
`;

export const IconTeam = styled(StyledIcon)`
    &:before {
        content:'\\e957';
    }
`;

export const IconCorporate = styled(StyledIcon)`
    &:before {
        content:'\\e959';
    }
`;

export const IconEmail = styled(StyledIcon)`
    &:before {
        content:'\\e958';
    }
`;

export const GeneralFile = styled(StyledIcon)`
    &:before {
        content:'\\e95b';
    }
`;

export const Doc1 = styled(StyledIcon)`
    &:before {
        content:'\\e960';
    }
`;

export const Generic1 = styled(StyledIcon)`
    &:before {
        content:'\\e961';
    }
`;

export const Pdf1 = styled(StyledIcon)`
    &:before {
        content:'\\e962';
    }
`;

export const Ppt1 = styled(StyledIcon)`
    &:before {
        content:'\\e963';
    }
`;

export const Txt1 = styled(StyledIcon)`
    &:before {
        content:'\\e964';
    }
`;

export const Xls1 = styled(StyledIcon)`
    &:before {
        content:'\\e965';
    }
`;

export const Collapse2 = styled(StyledIcon)`
    &:before {
        content:'\\e9f1';
    }
`;

export const DropDown = styled(StyledIcon)`
    &:before {
        content:'\\e9f2';
    }
`;

export const Expand2 = styled(StyledIcon)`
    &:before {
        content:'\\e9f3';
    }
`;

export const Notification = styled(StyledIcon)`
    &:before {
        content:'\\e9f4';
    }
`;

export const User2 = styled(StyledIcon)`
    &:before {
        content:'\\e9f5';
    }
`;

export const User = styled(StyledIcon)`
    &:before {
        content:'\\f001';
    }
`;

// to-do add:
// $rd-var-diagonal-arrow-down: \e966;
// $rd-var-diagonal-arrow-up: \e967;
// $rd-var-empty-state-3: \e968;
// $rd-var-empty-state-4: \e969;
// $rd-var-with-ledger: \e96a;
// $rd-var-without-ledger: \e96b;